import { render } from "./PlanSelector.vue?vue&type=template&id=0d2340c4&scoped=true"
import script from "./PlanSelector.vue?vue&type=script&lang=js"
export * from "./PlanSelector.vue?vue&type=script&lang=js"

import "./PlanSelector.vue?vue&type=style&index=0&id=0d2340c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d2340c4"]])

export default __exports__